import { createApiClient } from '@/shared/api/createApiClient';
import { addSpoofInterceptor } from '@/shared/spoof/addSpoofInterceptor';

export const adminApiClient = createApiClient(
  'admin_auth_token',
  'admin_active_tenant_id',
);

addSpoofInterceptor(adminApiClient, 'admin');
